<template>
    <div v-if="events.length" class="dr-events-swiper"> 
        <div class="swiper-container uk-position-relative" ref="eventSwiper">
            <div class="swiper-wrapper">
                <div v-for="(eventItem, index) in events" 
                     :key="eventItem.id || index" 
                     class="swiper-slide">
                    <dr-event-item
                        :eventItem="eventItem"
                        :eventItemType="getEventItemType(eventItem)"
                        :class="{'past-event': eventItem.status === 'past'}"
                    />
                </div>
            </div>
            <div class="swiper-pagination dr-events-swiper-pagination dr-swiperPagination"></div>
        </div>
    </div>
</template>

<script>
    import EventItem from "./Event-item.vue";
    import SwiperCore, { Pagination, Autoplay, Mousewheel } from 'swiper/core';
    
    import 'swiper/swiper.scss';
    import 'swiper/components/pagination/pagination.scss';
    
    SwiperCore.use([Pagination, Autoplay, Mousewheel]);

    export default {
        name: "Event-slider",
        components: {
            'dr-event-item': EventItem
        },
        props: {
            events: {
                type: Array,
                required: true
            },
            eventItemType: {
                type: String,
                default: 'event'
            }
        },
        methods: {
            initSwiper() {
                if (this.$refs.eventSwiper && !this.swiper) {
                    this.swiper = new SwiperCore(this.$refs.eventSwiper, this.swiperOptions);
                }
            },
            getEventItemType(eventItem) {
                if (eventItem && eventItem.filters && eventItem.filters['2027']) {
                    return this.$options.filters.array_key(eventItem.filters['2027']);
                }
                return this.eventItemType;
            }
        },
        data () {
            return {
                swiper: null,
                swiperOptions: {
                    loop: false,
                    watchOverflow: true,
                    slidesPerView: 1,
                    spaceBetween: 12,
                    centeredSlides: false,
                    autoplay: {
                        enabled: false,
                        delay: 4000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.dr-events-swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1025: {
                            slidesPerView: 1,
                            centeredSlides: false
                        }
                    },
                    observer: true,
                    observeParents: true,
                    mousewheel: true
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initSwiper();
            });
        },
        updated() {
            this.$nextTick(() => {
                if (this.swiper) {
                    this.swiper.update();
                }
            });
        },
        beforeDestroy() {
            if (this.swiper) {
                this.swiper.destroy();
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";

    .dr-events-swiper {
		margin-bottom: 60px;
	}
</style> 
